import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [authDashboard, setAuthDashboard] = useState({});

    return (
        <AuthContext.Provider value={{ authDashboard, setAuthDashboard }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;